import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ClientService } from './api/client.service';
import { ClientResourceService } from './api/clientResource.service';
import { MerchantService } from './api/merchant.service';
import { PrereconcileBillingService } from './api/prereconcileBilling.service';
import { ResourceService } from './api/resource.service';
import { ResourceMappingService } from './api/resourceMapping.service';
import { ResourceTransactionLogService } from './api/resourceTransactionLog.service';
import { TotalRevenueCardService } from './api/totalRevenueCard.service';
import { TotalRevenueReportService } from './api/totalRevenueReport.service';
import { TotalRouteCardService } from './api/totalRouteCard.service';
import { TransactionGraphService } from './api/transactionGraph.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ClientService,
    ClientResourceService,
    MerchantService,
    PrereconcileBillingService,
    ResourceService,
    ResourceMappingService,
    ResourceTransactionLogService,
    TotalRevenueCardService,
    TotalRevenueReportService,
    TotalRouteCardService,
    TransactionGraphService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
